import * as React from 'react';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';
import NumberFormat from 'react-number-format';

import PageBase from '../../../components/layout/PageBase';
import RentForm from '../../../components/pages/tools/rent-cruncher/RentForm';
import Tooltip from '../../../components/utility/Tooltip';
import Content from '../../../components/pages/tools/content/index';
import ToolsHeader from '../../../components/pages/tools/header/index';
import { isMobile } from '../../../lib/getDeviceSize';
import BackButton from '../../../components/utility/BackButton';

import style from '../../../styles/sass/pages/Tools.module.scss';
import { useRouter } from 'next/router';

const styles = createStyles({
  card: {
    margin: '0 auto',
    padding: 16,
    width: isMobile() ? 350 : 640,
  },
});

export interface Props {
  classes: any;
  rents: any;
}

export const RentCruncher = (props: Props) => {
  const [zip, setZip] = React.useState('');
  const router = useRouter();

  const handleZipSubmit = (zipCode: string) => {
    setZip(zipCode);
  };

  const RentItem = ({ label, data }: { label: string; data: number }) => (
    <div className={`row ${style.rentItem}`}>
      <p className={style.rentItemLabel}>{label}</p>
      <p className={style.rentItemValue}>
        {data ? (
          <NumberFormat
            value={data}
            displayType="text"
            thousandSeparator
            prefix="$"
            decimalScale={0}
          />
        ) : (
          'n/a'
        )}
      </p>
    </div>
  );

  const RentsList = ({ rents }: { rents: any }) => {
    return (
      <div>
        <div className={style.results}>
          <div className="row middle-xs center-xs">
            <h2>Average Rent/Month</h2>
            <Tooltip text="The average monthly rent for an entire unit, calculated over the past two months." />
          </div>
          <div className={`row ${style.rentItems}`}>
            <div className={`column ${style.column1}`}>
              <RentItem data={rents.studioAvg} label="Studio" />
              <RentItem data={rents.oneBedroomAvg} label="1 Bedroom" />
              <RentItem data={rents.twoBedroomAvg} label="2 Bedrooms" />
            </div>
            <div className={`column ${style.column2}`}>
              <RentItem data={rents.threeBedroomAvg} label="3 Bedrooms" />
              <RentItem data={rents.fourBedroomAvg} label="4 Bedrooms" />
              <RentItem data={rents.fiveBedroomAvg} label="5 Bedrooms" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const content = (needList: boolean) => {
    return (
      <Card className={props.classes.card}>
        <CardContent>
          <h3>Enter a zip code in to see what units are going for right now</h3>
          <br className="no-mobile" />
          <div className="column">
            <RentForm handleZipSubmit={handleZipSubmit} zip={zip} />
            {needList && <RentsList rents={props.rents} />}
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <PageBase title="How much should I charge for rent? | Torii Rent Cruncher">
      <BackButton goBack={() => router.push('/tools')} />
      <div
        className={`${style.toolContainer} tool-container ${style.rentCruncher} col-xs-12 center-xs`}
      >
        <ToolsHeader
          title="Rent Cruncher"
          slug="rent-cruncher"
          subTitle="Maximize your rental income"
        />

        <div className={`col-xs-12 ${style.toolContent} tool-content`}>
          {props.rents &&
          Object.keys(props.rents).length !== 0 &&
          props.rents.constructor === Object ? (
            content(true)
          ) : (
            <Content>{content(false)}</Content>
          )}
        </div>
      </div>
    </PageBase>
  );
};

const mapStateToProps = (state: any) => ({
  rents: state.listings.rents,
});

export default withStyles(styles)(connect(mapStateToProps)(RentCruncher));
